import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { GroupsService } from '../../../groups/groups.service';
import { AppCalendarService } from '../app-calendar.service';
import { CalendarFormDialogComponent } from '../calendar-form-dialog/calendar-form-dialog.component';

@Component({
  selector: 'app-calendar-config',
  templateUrl: './calendar-config.component.html',
  styleUrls: ['./calendar-config.component.scss'],
  standalone: false,
})
export class CalendarConfigComponent implements OnInit {
  dialogRef;
  viewDate;
  view;
  locale;
  groupList = [];
  selectedGroup = 'None';
  calendarEventSub: Subscription;
  translateSub: Subscription;

  constructor(
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    private calendarService: AppCalendarService,
    private groupService: GroupsService,
    private breakpointObserver: BreakpointObserver,
    private translate: TranslateService
  ) {
    this.calendarEventSub = this.calendarService.calendarEvents$.subscribe((res) => {
      if (res.event == 'calendar-variables') {
        this.view = res.data.view;
        this.locale = res.data.locale;
        this.viewDate = res.data.viewDate;
      }
    });
  }

  ngOnInit() {
    this.calendarService.sendCalendarEvent({ event: 'request-calendar-value' });
  }
  ngOnDestroy() {
    //   this.translateSub.unsubscribe()
    this.calendarEventSub.unsubscribe();
  }

  setView(view) {
    this.calendarService.sendCalendarEvent({
      event: 'view-change',
      data: view,
    });
  }

  groupSelected() {
    this.calendarService.sendCalendarEvent({
      event: 'group-selected',
      data: this.selectedGroup,
    });
  }

  refresh() {
    this.calendarService.sendCalendarEvent({ event: 'refresh' });
  }

  navButtonsClick(type) {
    this.calendarService.sendCalendarEvent({ event: type });
  }

  public addEvent() {
    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    let container;
    if (isSmallScreen) {
      container = this.bottomSheet;
    } else {
      container = this.dialog;
    }
    const ref = container.open(CalendarFormDialogComponent, {
      panelClass: 'calendar-form-dialog',
      data: {
        action: 'add',
        date: new Date(),
      },
      minWidth: '500px',
      maxWidth: '60vw',
      maxHeight: '80vh',
    });
    const onCloseSub = ref.afterClosed ? ref.afterClosed() : ref.afterDismissed();

    onCloseSub.subscribe((res) => {
      if (!res) {
        return;
      }
      const responseEvent = res.event;
      this.calendarService.addEvent(responseEvent).subscribe((events) => {
        this.refresh();
      });
    });
  }
}
